import { _ as _applyDecoratedDescriptor, a as _initializerDefineProperty } from '../_rollupPluginBabelHelpers-3b0ba74f.js';
import Component from '@glimmer/component';
import { service } from '@ember/service';
import { action } from '@ember/object';
import { precompileTemplate } from '@ember/template-compilation';
import { setComponentTemplate } from '@ember/component';

var TEMPLATE = precompileTemplate("{{#if this.isVisible}}\n  <div\n    class=\'translations-unavailable\'\n    role=\'alertdialog\'\n    aria-modal=\'true\'\n    data-test-translations-unavailable\n  >\n    <div class=\'translations-unavailable-panel\'>\n      <h4 data-test-translations-unavailable-title>\n        {{this.messages.title}}\n      </h4>\n\n      <p>\n        {{this.messages.body}}\n      </p>\n\n      <div class=\'translations-unavailable-actions\'>\n        <button\n          type=\'button\'\n          class=\'button\'\n          disabled={{this.intl.retryTranslationsTask.isRunning}}\n          data-test-translations-unavailable-retry\n          {{on \'click\' this.retry}}\n        >\n          {{this.messages.retry}}\n        </button>\n\n        <button\n          type=\'button\'\n          class=\'button secondary\'\n          data-test-translations-unavailable-reload\n          {{on \'click\' this.reload}}\n        >\n          {{this.messages.reload}}\n        </button>\n      </div>\n    </div>\n  </div>\n{{/if}}");

var _class, _descriptor;
const FALLBACK_LOCALE = 'it-it';

// Bundled on purpose: this is the one screen that must stay readable when the
// translation asset is unreachable. Kept deliberately tiny — bundling a full
// locale (~170 KB each) into every app to cover a rare boot failure would tax
// every successful load to pay for the failing one.
const MESSAGES = Object.freeze({
  'it-it': {
    title: 'Impossibile caricare le traduzioni',
    body: 'Le etichette dell’interfaccia non sono state scaricate, quindi i dati non sono modificabili in sicurezza. Controlla la connessione e riprova.',
    retry: 'Riprova',
    reload: 'Ricarica la pagina'
  },
  'en-us': {
    title: 'Translations could not be loaded',
    body: 'The interface labels were not downloaded, so your data cannot be edited safely. Check your connection and try again.',
    retry: 'Try again',
    reload: 'Reload the page'
  },
  'en-gb': {
    title: 'Translations could not be loaded',
    body: 'The interface labels were not downloaded, so your data cannot be edited safely. Check your connection and try again.',
    retry: 'Try again',
    reload: 'Reload the page'
  },
  'fr-fr': {
    title: 'Impossible de charger les traductions',
    body: 'Les libellés de l’interface n’ont pas été téléchargés, vos données ne peuvent donc pas être modifiées en toute sécurité. Vérifiez votre connexion et réessayez.',
    retry: 'Réessayer',
    reload: 'Recharger la page'
  },
  'de-de': {
    title: 'Übersetzungen konnten nicht geladen werden',
    body: 'Die Beschriftungen der Oberfläche wurden nicht geladen, daher können Ihre Daten nicht sicher bearbeitet werden. Prüfen Sie die Verbindung und versuchen Sie es erneut.',
    retry: 'Erneut versuchen',
    reload: 'Seite neu laden'
  }
});
let BbTranslationsUnavailableComponent = (_class = class BbTranslationsUnavailableComponent extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "intl", _descriptor, this);
  }
  get isVisible() {
    return this.intl.translationsUnavailable;
  }

  /**
   * The locale we failed on is the user's best guess at a readable language;
   * the browser language is the fallback when the failure happened before any
   * locale was chosen.
   */
  get messages() {
    const candidates = [this.intl.failedLocale, navigator.languages?.[0], navigator.language, FALLBACK_LOCALE];
    for (const candidate of candidates) {
      if (!candidate) continue;
      const normalized = candidate.toLowerCase();
      // `navigator.language` is often the bare language ("it", "de"): match the
      // first regional entry for it rather than dropping straight to Italian.
      const key = normalized in MESSAGES ? normalized : Object.keys(MESSAGES).find(locale => locale.startsWith(`${normalized.slice(0, 2)}-`));
      if (key) {
        return MESSAGES[key];
      }
    }
    return MESSAGES[FALLBACK_LOCALE];
  }
  retry() {
    this.intl.retryTranslationsTask.perform();
  }
  reload() {
    window.location.reload();
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "retry", [action], Object.getOwnPropertyDescriptor(_class.prototype, "retry"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "reload", [action], Object.getOwnPropertyDescriptor(_class.prototype, "reload"), _class.prototype), _class);
setComponentTemplate(TEMPLATE, BbTranslationsUnavailableComponent);

export { BbTranslationsUnavailableComponent as default };
//# sourceMappingURL=bb-translations-unavailable.js.map
